import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import How from "@/components/sections/How";
import Coverage from "@/components/sections/Coverage";

const Home = () => {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#FAF9F6]">
      <Header />
      <main>
        <Hero />
        <Services />
        <How />
        <Coverage />
        {/* Google Map Section */}
<div style={{ width: '100%', overflow: 'hidden', borderRadius: '8px', margin: '40px 0', boxShadow: '0 4px 10px rgba(0,0,0,0.08)', position: 'relative' }}>
  <iframe 
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.842777174174!2d46.6613523!3d24.757823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f038cf5668e27%3A0x6b83f3950b73afb3!2sTalibnaz%20Maintenance%20Services!5e0!3m2!1sen!2ssa!4v1721237685000!5m2!1sen!2ssa" 
    width="100%" 
    height="450" 
    style={{ border: 0 }} 
    allowFullScreen={true} 
    loading="lazy" 
    referrerPolicy="no-referrer-when-downgrade"
  >
  </iframe>

  {/* Overlay: covers Google's own "Open in Maps" button so it points to our GBP link */}
  <a
    href="https://maps.app.goo.gl/Xfqnm8HL2UGZWeGu7"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '180px',
      height: '50px',
      zIndex: 10,
    }}
    aria-label="Open Talibnaz Google Business Profile"
  ></a>

  <div style={{ textAlign: 'center', marginTop: '12px' }}>
    <a 
      href="https://maps.app.goo.gl/Xfqnm8HL2UGZWeGu7" 
      target="_blank" 
      rel="noopener noreferrer" 
      style={{ color: '#2fa84f', fontWeight: 600, textDecoration: 'none', fontFamily: 'Poppins, sans-serif' }}
    >
      Open in Google Maps →
    </a>
  </div>
</div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default Home;
